import { call, put, select, takeLatest } from "redux-saga/effects";
import { postGiftFinderSearchAPI } from "../../../api/giftFinderApi";
import {
  failedGiftFinderLoadMoreAction,
  failedGiftFinderResultsAction,
  requestGiftFinderLoadMoreAction,
  requestGiftFinderResultsAction,
  responseGiftFinderLoadMoreAction,
  responseGiftFinderResultsAction,
} from "../../slices/giftFinderSlice";

/**
 * Run a fresh search (page 0).
 *
 * Note there is no try/catch: the interceptor resolves rather than rejects on failure,
 * so the API module returns a normalized `{ok, error}` and that is what must be branched on.
 *
 * @param {Object} action
 */
function* fetchGiftFinderResultsSaga(action) {
  const body = action.payload?.body;
  const isMobile = action.payload?.isMobile;

  const result = yield call(postGiftFinderSearchAPI, body, { isMobile });

  if (!result?.ok) {
    yield put(failedGiftFinderResultsAction(result?.error ?? null));
    return;
  }

  yield put(responseGiftFinderResultsAction({ response: result.data, request: body }));
}

/**
 * Append the next page. The page number is derived from store state rather than the
 * action payload so a double-tap cannot skip or repeat a page.
 *
 * @param {Object} action
 */
function* fetchGiftFinderLoadMoreSaga(action) {
  const isMobile = action.payload?.isMobile;
  const { request, currentPage, totalPages } = yield select((state) => state?.giftFinder ?? {});

  const nextPage = (currentPage ?? 0) + 1;
  if (!request || nextPage >= (totalPages ?? 0)) {
    yield put(failedGiftFinderLoadMoreAction(null));
    return;
  }

  const result = yield call(postGiftFinderSearchAPI, { ...request, page: nextPage }, { isMobile });

  if (!result?.ok) {
    yield put(failedGiftFinderLoadMoreAction(result?.error ?? null));
    return;
  }

  yield put(responseGiftFinderLoadMoreAction({ response: result.data }));
}

/** Root watcher for gift-finder results. */
export function* watcherGiftFinderSaga() {
  // takeLatest: rapid chip removals should resolve to the last request only.
  yield takeLatest(requestGiftFinderResultsAction.type, fetchGiftFinderResultsSaga);
  yield takeLatest(requestGiftFinderLoadMoreAction.type, fetchGiftFinderLoadMoreSaga);
}

export default watcherGiftFinderSaga;
